import routes from '@/modules/administrator/administrator-routes';
import store from '@/modules/administrator/administrator-store';

export default {
    routes,
    store,
};
